var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.businesses),function(business){return _c('span',{key:business.id},[_vm._v("\n    "+_vm._s(business.name)+"\n    "),_c('span',[_vm._v(_vm._s(_vm.getSeparator(business.id)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }